//import { customAttribute, inject, bindingMode } from 'aurelia-framework';
//import * as $ from "jquery";
//import 'jquery-ui-dist/jquery-ui';
////import "jquery-ui-touch-punch";

//@customAttribute('draggable', bindingMode.twoWay)
//@inject(Element)
//export class Draggable {
//    constructor(private element:Element) {
//        this.element = element;
//    }

//  attached() {
//        // TODO: asp.net core 2.1
//        ($(this.element) as any).draggable();
//    }
//}